type Primitive = string | number | boolean | null | undefined;
type NestedObject = {
    [key: string]: Primitive | NestedObject | Array<Primitive>;
};
// Flattens an object with nested objects and arrays into a single level object.
export const flattenObject = (
    obj: NestedObject,
    parentKey: string = "",
    result: Record<string, Primitive | Array<Primitive>> = {},
): Record<string, Primitive | Array<Primitive>> => {
    for (const key in obj) {
        const value = obj[key];
        const newKey = parentKey ? `${parentKey}[${key}]` : key;

        if (typeof value === "object" && value !== null && !Array.isArray(value)) {
            flattenObject(value as NestedObject, newKey, result);
        } else {
            result[newKey] = value as Primitive | Array<Primitive>;
        }
    }
    return result;
};
